export const formatUSD = (value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

/**
 * Currency-guarded cost formatter. USD is the asserted backend contract, so
 * USD is the only supported render path: `currency === 'USD'` formats exactly
 * like {@link formatUSD} (byte-identical `$X.XX`). Any other currency code
 * returns `null` so callers degrade gracefully (`—` / hidden chip) rather than
 * rendering a misleading `$` against non-USD money. This is the single shared
 * guard used by both the conversation CostChip and the hunt cost tile — do NOT
 * build multi-currency formatting here (no requirement exists).
 */
export const formatCost = (value: number, currency: string): string | null =>
  currency === 'USD' ? formatUSD(value) : null;
